/* @generated from adl module ferovinum.app.uiconfig */

import * as ADL from './../../runtime/adl';
import * as ferovinum_app_config from './config';

/**
 * Configuration for the web frontend.
 */
export interface UiConfig {
  /**
   * Application title
   */
  title: string;
  /**
   * The URL of the trade sale terms and conditions PDF
   */
  ferovinumTermsAndConditionsUrl: string;
  /**
   * The URL of the user manual
   */
  userManualUrl: string;
  /**
   * Environment name, e.g. dev, uat, prod
   */
  environment: string;
  /**
   * Name of the release / code version
   */
  releaseName: string;
  /**
   * Email Intelligence configuration
   */
  emailIntelligenceConfig: ferovinum_app_config.EmailIntelligenceConfig;
  hotjarConfig: ferovinum_app_config.HotjarConfig;
  /**
   * API domain URL eg. https://api.fero.capital
   */
  apiDomainUrl: string;
}

export function makeUiConfig(
  input: {
    title?: string,
    ferovinumTermsAndConditionsUrl?: string,
    userManualUrl?: string,
    environment: string,
    releaseName: string,
    emailIntelligenceConfig: ferovinum_app_config.EmailIntelligenceConfig,
    hotjarConfig: ferovinum_app_config.HotjarConfig,
    apiDomainUrl: string,
  }
): UiConfig {
  return {
    title: input.title === undefined ? "" : input.title,
    ferovinumTermsAndConditionsUrl: input.ferovinumTermsAndConditionsUrl === undefined ? "https://com-hx-ferovinum-assets.s3.eu-west-2.amazonaws.com/files/ferovinum-general_terms_and_conditions_2025.pdf" : input.ferovinumTermsAndConditionsUrl,
    userManualUrl: input.userManualUrl === undefined ? "https://amusing-poppy-236.notion.site/ebd/20d82543f57a80c58bf2cbd29613b78e" : input.userManualUrl,
    environment: input.environment,
    releaseName: input.releaseName,
    emailIntelligenceConfig: input.emailIntelligenceConfig,
    hotjarConfig: input.hotjarConfig,
    apiDomainUrl: input.apiDomainUrl,
  };
}

const UiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.uiconfig","decl":{"annotations":[{"value":"Configuration for the web frontend.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Application title\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"title","default":{"kind":"just","value":""},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The URL of the trade sale terms and conditions PDF\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"ferovinumTermsAndConditionsUrl","default":{"kind":"just","value":"https://com-hx-ferovinum-assets.s3.eu-west-2.amazonaws.com/files/ferovinum-general_terms_and_conditions_2025.pdf"},"name":"ferovinumTermsAndConditionsUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The URL of the user manual\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"userManualUrl","default":{"kind":"just","value":"https://amusing-poppy-236.notion.site/ebd/20d82543f57a80c58bf2cbd29613b78e"},"name":"userManualUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Environment name, e.g. dev, uat, prod\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"environment","default":{"kind":"nothing"},"name":"environment","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Name of the release / code version\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"releaseName","default":{"kind":"nothing"},"name":"releaseName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Email Intelligence configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"emailIntelligenceConfig","default":{"kind":"nothing"},"name":"emailIntelligenceConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"EmailIntelligenceConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"hotjarConfig","default":{"kind":"nothing"},"name":"hotjarConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"HotjarConfig"}},"parameters":[]}},{"annotations":[{"value":"API domain URL eg. https://api.fero.capital\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"apiDomainUrl","default":{"kind":"nothing"},"name":"apiDomainUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UiConfig","version":{"kind":"nothing"}}};

export const snUiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.uiconfig", name:"UiConfig"};

export function texprUiConfig(): ADL.ATypeExpr<UiConfig> {
  return {value : {typeRef : {kind: "reference", value : snUiConfig}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.uiconfig.UiConfig" : UiConfig_AST
};
